import { motion } from 'framer-motion';

const FadeIn = ({ children, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function TermsPage() {
  return (
    <main className="pt-20">
      <section className="py-16 bg-[rgb(17,17,19)] relative">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize: '32px 32px' }} />
        <div className="max-w-[800px] mx-auto px-6 relative">
          <FadeIn>
            <span className="text-[#F37021] text-sm font-semibold tracking-widest uppercase">Legal</span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">Terms & Conditions</h1>
            <p className="text-[rgb(161,161,170)] text-sm">Last updated: August 2025</p>
          </FadeIn>
        </div>
      </section>

      <section className="py-16 bg-[rgb(17,17,19)]">
        <div className="max-w-[800px] mx-auto px-6">
          <FadeIn>
            <div className="prose prose-invert max-w-none space-y-8">
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">By accessing and using the Scaleup Academy website, you accept and agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use our website.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">2. Services</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Scaleup Academy provides coaching services for CLAT, CUET, IELTS, and Spoken English. The details of each course, including duration, fees, and curriculum, are subject to change and will be communicated during the enrollment process.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">3. Enrollment & Fees</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Enrollment is confirmed upon payment of the applicable fees. Fee structures are provided during counselling sessions. Refund policies vary by program and will be communicated at the time of enrollment.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">4. Student Conduct</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Students are expected to maintain discipline and respect within the academy premises and during online sessions. Any disruptive or inappropriate behavior may result in suspension or termination of enrollment.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">5. Intellectual Property</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">All study materials, content, and resources provided by Scaleup Academy are proprietary. Unauthorized reproduction, distribution, or sharing of these materials is strictly prohibited.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">6. Limitation of Liability</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Scaleup Academy shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services or website. Results may vary based on individual effort and aptitude.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">7. Modifications</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Scaleup Academy reserves the right to modify these terms at any time. Changes will be posted on this page with an updated revision date. Continued use of the website constitutes acceptance of modified terms.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">8. Governing Law</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Noida, Uttar Pradesh.</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
}
